const changeVideowisePositionOnDesktop = () => {
  if (window.matchMedia('(max-width: 768px)').matches) return;

  const newVideowiseWrapper = document.createElement('div');
  newVideowiseWrapper.classList.add('product-block', 'small--hide', 'medium-up--show');
  newVideowiseWrapper.style.marginTop = '46px';

  const productContent = document.querySelector('.product-grid__container .product-grid__content');
  const videowiseElement = document.querySelector('[id*="reeview-app-widget_"]');

  if (!productContent || !videowiseElement) return;

  newVideowiseWrapper.appendChild(videowiseElement);
  productContent.appendChild(newVideowiseWrapper);
}

if (document.readyState !== "loading") {
  // if the page is already ready, execute now
  changeVideowisePositionOnDesktop();
} else {
  // otherwise, add a listener
  document.addEventListener('DOMContentLoaded', changeVideowisePositionOnDesktop);
}